module.exports = __webpack_public_path__ + "static/media/Ellipse 6.95582b71.png";